module.exports = __webpack_public_path__ + "static/media/faq_(7).f46f494c.gif";